<template>
    <div class="marker-info-modal" v-if="display" :class="{shadow: shadowBlock}">
        <ul>
            <!--<li class="close">-->
            <!--<button @click="infoWinOpen=false"></button>-->
            <!--</li>-->
            <li class="place-preview">
                <div class="top">
                    <div class="image">
                        <img :src="placeInfo.place.preview" @click="infoWinOpen=false">
                    </div>
                    <div class="address">
										<span @click="onPlaceTitleClick">
											<router-link class="title"
                                                         :to="{name: 'place', params: {id: placeInfo.place.uid}}">{{placeInfo.place.name}}</router-link>
										</span>
                        <address>
                            <span>{{placeInfo.place.address}}</span>
                        </address>
                    </div>
                </div>
                <div class="bottom">
                    <div class="you-vote">
                        <span class="title" v-text="translate('YourVotes')"></span>
                        <b>{{placeInfo.place.my_rates_count}}</b>
                    </div>
                    <div class="users-vote">
                        <span class="title" v-text="translate('OtherVotes')"> </span>
                        <ul>
                            <li>
                                <div class="image cool">
                                    <img src="@/assets/icons/smile-simple.svg" alt="">
                                </div>
                                <b>{{placeInfo.place.rates_info.rate3}}</b>
                            </li>
                            <li>
                                <div class="image soso">
                                    <img src="@/assets/icons/normal-simple.svg" alt="">
                                </div>
                                <b>{{placeInfo.place.rates_info.rate2}}</b>
                            </li>
                            <li>
                                <div class="image meh">
                                    <img src="@/assets/icons/sad-simple.svg" alt="">
                                </div>
                                <b>{{placeInfo.place.rates_info.rate1}}</b>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>

    // Import heplers
    import logAnalyticsEvent from '@/helpers/analytics'

    export default {
        name: 'placeMarkerInfoModal',
        mixins: [],
        props: {
            display: {
                type: Boolean,
                default: false
            },

            placeInfo: {
                type: Object,
                default: () => {
                }
            },

            shadowBlock: {
                type: Boolean,
                default: false
            },
        },

        methods: {
            onPlaceTitleClick() {
                if (this.$store.state.search.activeSearch) {
                    logAnalyticsEvent('map_place_card_click')
                }
            }
        },
    }
</script>

<style scoped>
    .marker-info-modal {
        display: flex;
        background: #fff;
        width: 96%;
        position: fixed;
        text-align: left;
        bottom: 0;
        margin: 2%;
        padding: 0.4em;
        z-index: 5;
    }

    .marker-info-modal.shadow {
        box-shadow: 0px 0px 5px #eee;
    }

    .marker-info-modal > ul {
        margin-bottom: 0.5em;
        width: 100%;
    }
</style>